// Création de l'objet à envoyer au back
const formaterModifierQuestionsReponses = (dataForm) => {
    return {
        question1: dataForm.question1,
        question2: dataForm.question2,
        question3: dataForm.question3,
        reponse1: dataForm.reponse1,
        reponse2: dataForm.reponse2,
        reponse3: dataForm.reponse3,
    };
};

export default formaterModifierQuestionsReponses;
